import NavBar from "./Components/NavBar";
import "./CSS/reporte.css";
import React, { useState, useEffect } from "react";
import { useRef } from "react";

import { useNavigate, useParams, Link } from "react-router-dom";
import {
  collection,
  getDocs,
  query,
  where,
  deleteDoc,
  doc,
  orderBy,
} from "firebase/firestore";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { db } from "./FirebaseConfig/firebase";
import Button from "@mui/material/Button";

import { CSVLink } from "react-csv";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { utils } from "xlsx";

//REPORTES POR MESA

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import TableBarIcon from "@mui/icons-material/TableBar";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
const MySwal = withReactContent(Swal);
function ReporteSalon() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [codigosList, setCodigosList] = useState([]);
  const [codIngeniero, setCodIngeniero] = useState();

  const [pollo, setPollo] = React.useState(0);
  const [chancho, setChancho] = React.useState(0);
  const [vegetariano, setVegetariano] = React.useState(0);
  const [tipoEvento, setTipoEvento] = React.useState(
    localStorage.getItem("tipoEventoSalon")
  );
  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA
  const [tablesSeats, setTablesSeats] = useState([]);
  const [asientosString, setAsientosString] = useState("");
  const [showMore, setShowMore] = useState(false);
  const [alignment, setAlignment] = React.useState("usuarios");
  const [datos, setDatos] = useState({});
  const [pruebitas, setPruebitas] = useState({});
  const [detallesMesas, setDetallesMesas] = useState([]);

  const [registroMesas, setRegistroMesas] = useState([]);

  const tdRef = useRef(null);

  const agregarObjeto = (nroMesa, detalles) => {
    const nuevoObjeto = { nroMesa: nroMesa, detalles: detalles };
    setRegistroMesas([...registroMesas, nuevoObjeto]);
  };
  function MesaUsuarios() {
    const mesas = {};
    for (const usuario in datos) {
      const asientos = datos[usuario];
      for (const asiento of asientos) {
        const mesa = asiento.substring(0, asiento.length - 1);
        const letra = asiento.substring(asiento.length - 1);
        if (!mesas[mesa]) {
          mesas[mesa] = {};
        }
        if (!mesas[mesa][usuario]) {
          mesas[mesa][usuario] = [];
        }
        mesas[mesa][usuario].push(letra);
      }
    }

    const mesasOrdenadas = Object.keys(mesas).sort((a, b) => a - b);

    const tablaFilas = mesasOrdenadas.map((mesa) => {
      const usuarios = Object.keys(mesas[mesa]).map((usuario) => {
        const usuarioEncontrado = codigosList.find(
          (itemUsuario) =>
            itemUsuario.nombre + " " + itemUsuario.apellidos == usuario
        );

        const asientos = mesas[mesa][usuario].join(",");
        const respuesta = `${usuario} (${asientos})${
          usuarioEncontrado.chancho > 0
            ? `CHANCHO:${usuarioEncontrado.chancho} `
            : ""
        }${
          usuarioEncontrado.vegetariano > 0
            ? `VEGETARIANO:${usuarioEncontrado.vegetariano} `
            : ""
        } ${
          usuarioEncontrado.pollo > 0 ? `POLLO:${usuarioEncontrado.pollo} ` : ""
        } ` +"\n";

        return [respuesta];
      });
      pruebitas[`Mesa ${mesa}`] = usuarios.join(", ");
      return (
        <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
          <TableCell style={{ height: "50px" }} align="center">
            Mesa {mesa}
          </TableCell>
          <TableCell style={{ height: "50px" }} align="center">
            <pre style={{fontFamily:"sans-serif"}} >{usuarios}</pre>
          </TableCell>
        </TableRow>
      );
    });
    return (
      <div className="reporte-tabla">
        <h2>Reporte por mesas:</h2>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="center">NRO DE MESA</TableCell>
                <TableCell align="center">INGENIERO(S) POR MESA</TableCell>
              </TableRow>
            </TableHead>
            <tbody>{tablaFilas}</tbody>
          </Table>
        </TableContainer>
      </div>
    );
  }

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      console.log(newAlignment);
      setAlignment(newAlignment);
    }
  };
  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }
  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  //FOR DE FORS
  const buscarCodigos = async () => {
    const cuponesList = collection(db, `EVENTOS/${id}/AsientosRegistrados`);
    const q = query(cuponesList, orderBy("nroTicket", "desc"));
    const data = await getDocs(q);
    setCodigosList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    setDatosCargados(true);
  };
  function groupTablesSeats(listadeasientos) {
    const mesas = {};
    listadeasientos
      .split(",")
      .sort()
      .forEach((asiento) => {
        const numeroMesa = asiento.slice(0, -1);
        const letraAsiento = asiento.slice(-1);

        if (!mesas[numeroMesa]) {
          mesas[numeroMesa] = [];
        }

        mesas[numeroMesa].push(letraAsiento);
      });
    let resultado = "";
    Object.entries(mesas).map(
      ([numeroMesa, letraAsiento]) =>
        (resultado =
          resultado +
          `Mesa ${numeroMesa}` +
          " \n" +
          `(${letraAsiento.sort().join(",")}` +
          ") \n")
    );
    //console.log(resultado);

    if (resultado) {
      const final = resultado.toString();
      return (
        <div>
          {showMore ? final : final.slice(0, 100)}
          {final.length > 100 ? (
            <button onClick={toggleShowMore} className="text-button">
              {showMore ? "Ver menos" : "Ver más ... "}
            </button>
          ) : null}
        </div>
      );
    }
  }
  function prueba(listadeasientos) {
    groupTablesSeats(listadeasientos);
    //return <div>{listadeasientos}</div>;
  }
  useEffect(() => {
    let sumaPollo = 0;
    let sumaChancho = 0;
    let sumaVegetariano = 0;

    for (let i = 0; i < codigosList.length; i++) {
      if (codigosList[i].pollo) {
        sumaPollo = sumaPollo + codigosList[i].pollo;
      }
      if (codigosList[i].chancho) {
        sumaChancho = sumaChancho + codigosList[i].chancho;
      }
      if (codigosList[i].vegetariano) {
        sumaVegetariano = sumaVegetariano + codigosList[i].vegetariano;
      }
    }
    setPollo(sumaPollo);
    setChancho(sumaChancho);
    setVegetariano(sumaVegetariano);
  }, [codigosList]);
  //cerrar cupones
  const cerrar = () => {
    navigate(`../eventos/${id}/registrarParticipanteSalon`);
  };
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-success",
      cancelButton: "btn btn-danger",
    },
    buttonsStyling: false,
  });
  const buscarIdUsuario = async (idTicket, CIPingeniero, listAsientos) => {
    swalWithBootstrapButtons
      .fire({
        title: "Eliminar reserva?",
        text: "El usuario ya no podra ver su entrada",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, eliminar!",
        cancelButtonText: "No, cancelar!",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const q = query(
            collection(db, "USUARIOS"),
            where("cip", "==", CIPingeniero)
          );
          const querySnapshot = await getDocs(q);
          querySnapshot.forEach((doc) => {
            borrarTicketUsuario(doc.id, listAsientos, idTicket);
          });
          swalWithBootstrapButtons.fire(
            "Eliminado!",
            "La reserva ha sido eliminada",
            "success"
          );
          buscarCodigos();
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.cancel
        ) {
          swalWithBootstrapButtons.fire(
            "Cancelado",
            "La entrada no se elimino :)",
            "warning"
          );
        }
      });
  };
  const borrarTicketUsuario = async (idUsuario, listAsientos, idTicket) => {
    const q = query(
      collection(db, `USUARIOS/${idUsuario}/AsientosRegistrados`),
      where("asientos", "==", listAsientos)
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(async (docume) => {
      const usuario = doc(
        db,
        `USUARIOS/${idUsuario}/AsientosRegistrados`,
        docume.id
      );
      await deleteDoc(usuario);
      await deleteDoc(doc(db, `EVENTOS/${id}/AsientosRegistrados`, idTicket));
      buscarCodigos();
    });
  };
  const descargarTabla = () => {
    if (alignment == "usuarios") {
      const header = [
        "NRO TICKET",
        "CIP",
        "APELLIDOS",
        "NOMBRES",
        "ASIENTOS",
        "POLLO",
        "CHANCHO",
        "VEGETARIANO",
        "FECHA",
      ];
      const dataWithHeader = [
        header,
        ...codigosList.map((item) => [
          item.nroTicket,
          item.CIP,
          item.apellidos,
          item.nombre,
          item.asientos,
          item.pollo,
          item.chancho,
          item.vegetariano,
          item.fecha,
        ]),
      ];
      exportToXlsx(dataWithHeader);
    } else {
      console.log(pruebitas);
      const detalles = [];
      for (let mesa in pruebitas) {
        const nuevoDato = { mesa: mesa, detalles: pruebitas[mesa] };
        detalles.push(nuevoDato); // Opción 1: utilizando concat()
      }
      console.log(detalles);

      const header = ["NRO DE MESA", "INGENIEROS POR MESA"];
      const dataWithHeader = [
        header,
        ...detalles.map((item) => [item.mesa, item.detalles]),
      ];
      exportToXlsxMESAS(dataWithHeader);
    }
  };

  function exportToXlsxMESAS(data) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet["!rows"] = [
      {
        height: 30,
        cells: [{ style: { fill: { fgColor: { rgb: "FFFF0000" } } } }],
      },
    ];

    worksheet["!cols"] = [
      { wch: 10 }, // Ancho de la primera columna
      { wch: 50 }, // Ancho de la segunda columna
    ];
    worksheet["!ref"] = `A2:${utils.encode_col(headers.length - 1)}${
      data.length + 1
    }`;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const file = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    saveAs(
      new Blob([s2ab(file)], { type: "application/octet-stream" }),
      "ReporteMesas.xlsx"
    );
  }
  function exportToXlsx(data) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    worksheet["!rows"] = [
      {
        height: 30,
        cells: [{ style: { fill: { fgColor: { rgb: "FFFF0000" } } } }],
      },
    ];

    worksheet["!cols"] = [
      { wch: 10 }, // Ancho de la primera columna
      { wch: 10 }, // Ancho de la segunda columna
      { wch: 30 }, // Ancho de la tercera columna
      { wch: 30 },
      { wch: 30 },
      { wch: 5 },
      { wch: 5 },
      { wch: 5 },
      { wch: 20 },
    ];
    worksheet["!ref"] = `A2:${utils.encode_col(headers.length - 1)}${
      data.length + 1
    }`;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const file = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    saveAs(
      new Blob([s2ab(file)], { type: "application/octet-stream" }),
      "ReporteUsuarios.xlsx"
    );
  }
  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }
  const headers = [
    { label: "NRO TICKET", key: "NRO TICKET" },
    { label: "CIP", key: "CIP" },
    { label: "APELLIDOS", key: "apellidos" },
    { label: "NOMBRES", key: "nombre" },
    { label: "ASIENTOS", key: "asientos" },
    { label: "POLLO", key: "POLLO" },
    { label: "CHANCHO", key: "CHANCHO" },
    { label: "VEGETARIANO", key: "VEGETARIANO" },

    { label: "FECHA", key: "fecha" },
  ];

  useEffect(() => {
    if (codIngeniero) {
      //console.log("Buenos dias estrellitas");
    } else {
    }
  }, [codIngeniero]);

  useEffect(() => {
    buscarCodigos();
  }, []);
  useEffect(() => {
    //console.log(codigosList);

    codigosList.map((elemento, index) => {
      if (elemento.nombre != "CIP") {
        const nuevoUsuario = elemento.nombre + " " + elemento.apellidos;
        const nuevosAsientos = elemento.asientos.split(",");
        datos[nuevoUsuario] = nuevosAsientos;
      }
    });
  }, [codigosList]);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="panel">
      <NavBar
        titulo="REPORTES"
        nombre=""
        imagen="cerrar"
        logoTitulo="cupon"
        cerrar={cerrar}
      ></NavBar>
      <div className="reporte-cabecera">
        <h1 className="cd">Ingenieros registrados : {codigosList.length-1}</h1>
      </div>
      {tipoEvento != "Pago (sin comida)" ? (
        <div className="reporte-cabecera-salon">
          <div>
            <h1 className="cd-salon">Pollo</h1>
            <img
              src={require(`./img/pollo.png`)}
              alt="logo-titulo"
              className="iconos-comidas"
            />
            <h1 className="cd-salon">{pollo}</h1>
          </div>
          <div>
            <h1 className="cd-salon">Chancho</h1>
            <img
              src={require(`./img/chancho.png`)}
              alt="logo-titulo"
              className="iconos-comidas"
            />
            <h1 className="cd-salon">{chancho}</h1>
          </div>

          <div>
            <h1 className="cd-salon">Vegetariano</h1>
            <img
              src={require(`./img/vege.png`)}
              alt="logo-titulo"
              className="iconos-comidas"
            />
            <h1 className="cd-salon">{vegetariano}</h1>
          </div>
        </div>
      ) : null}

      <div className="descargar">
        <Button
          variant="contained"
          color="success"
          onClick={() => {
            descargarTabla();
          }}
        >
          Descargar REPORTE
        </Button>
      </div>
      <div className="descargar" style={{ paddingTop: "30px" }}>
        <ToggleButtonGroup
          value={alignment}
          exclusive
          onChange={handleAlignment}
          aria-label="text alignment"
        >
          <ToggleButton value="usuarios" aria-label="left aligned">
            <AccessibilityNewIcon />
          </ToggleButton>
          <ToggleButton value="mesas" aria-label="centered">
            <TableBarIcon />
          </ToggleButton>
        </ToggleButtonGroup>
      </div>
      {alignment == "usuarios" ? (
        <div className="reporte-tabla">
          <h2>Reporte por usuarios:</h2>

          <TableContainer component={Paper}>
            <Table
              sx={{ minWidth: 650 }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    <b>Nro Ticket</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>CODIGO CIP USUARIO</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>APELLIDOS</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>NOMBRES</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>ASIENTOS COMPRADOS</b>
                  </TableCell>
                  {tipoEvento != "Pago (sin comida)" ? (
                    <TableCell align="center">
                      <b>Comidas</b>
                    </TableCell>
                  ) : null}

                  <TableCell align="center">
                    <b>FECHA DE COMPRA</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>TICKET</b>
                  </TableCell>
                  <TableCell align="center">
                    <b>BORRAR</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {codigosList.map((row) => (
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="center">{row.nroTicket}</TableCell>

                    <TableCell align="center">{row.CIP}</TableCell>
                    <TableCell align="center">{row.apellidos}</TableCell>
                    <TableCell align="center">{row.nombre}</TableCell>
                    <TableCell style={{ width: "3px" }} align="center">
                      {groupTablesSeats(row.asientos)}
                    </TableCell>
                    {tipoEvento != "Pago (sin comida)" ? (
                      <TableCell align="center">
                        {row.chancho > 0 ? `Chancho:${row.chancho} ` : null}{" "}
                        {row.vegetariano > 0
                          ? `Vegeteriano:${row.vegetariano} `
                          : null}
                        {row.pollo > 0 ? `Pollo:${row.pollo} ` : null}{" "}
                      </TableCell>
                    ) : null}

                    <TableCell align="center">{row.fecha}</TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="success"
                        onClick={() => {
                          navigate(
                            `/eventos/${id}/registrarParticipante/${row.id}`
                          );
                        }}
                      >
                        Ver Entrada
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          //borrarTicket(row.id);
                          buscarIdUsuario(row.id, row.CIP, row.asientos);
                          //borrarTicketUsuario(row.asientos)
                        }}
                      >
                        BORRAR
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        MesaUsuarios()
      )}
    </div>
  );
}

export default ReporteSalon;
